import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const sessionLimitBlockStyleId = 'wb-v2-session-limit-block-theme';

export const sessionLimitBlockBridgeStyles = {
  'wb-session-limit-block': {
    '--local-session-limit-page-bg': tokens.color.background.primary,
  },
};
